import { useEffect } from "react";

const INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID; // Replace with your real App ID

const IntercomProvider = () => {
  useEffect(() => {
    // Set Intercom settings
    window.intercomSettings = {
      app_id: INTERCOM_APP_ID,
      // DO NOT add hide_default_launcher
    };

    // Load Intercom script
    (function () {
      const w = window ;
      const ic = w.Intercom;
      if (typeof ic === "function") {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        const i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        const l = function () {
          const s = document.createElement("script");
          s.type = "text/javascript";
          s.async = true;
          s.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
          const x = document.getElementsByTagName("script")[0];
          x.parentNode?.insertBefore(s, x);
        };
        if (w.attachEvent) {
          w.attachEvent("onload", l);
        } else {
          w.addEventListener("load", l, false);
        }
      }
    })();
  }, []);

  return null; // This component doesn't render anything
};

export default IntercomProvider;
